import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { Button, ButtonSizes } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import Global from '../../../store/global-selectors';
import { UserPermissionService } from '../../../services/user-permission-service';

import { messages } from '../../messages';
import style from '../item-list.module.less';

export const ListHeader = ({ onVerifyAllItems, onClearAllItems }) => {
  const userRoles = useSelector(Global.selectUseruserRoles) || [];
  const hasPackingScanPermission = UserPermissionService.userHasPackingScanManualVerificationRole(userRoles);

  return (
    <>
      <div className={style['header-cell']} />
      <div className={style['header-cell']} />
      <FlexRow className={style['header-cell']}>
        {hasPackingScanPermission && (
          <>
            <Button buttonSize={ButtonSizes.large} onClick={onVerifyAllItems} theme='link'>
              <FormattedMessage {...messages.listHeaderVerifyAll} />
            </Button>
            <Button buttonSize={ButtonSizes.large} onClick={onClearAllItems} theme='link'>
              <FormattedMessage {...messages.listHeaderClearAll} />
            </Button>
          </>
        )}
      </FlexRow>
      <Text className={style['header-cell']} textType={TextType.Paragraph} value={messages.listHeaderOrderQty} />
      <Text className={style['header-cell']} textType={TextType.Paragraph} value={messages.listHeaderScanned} />
    </>
  );
};

ListHeader.propTypes = {
  onVerifyAllItems: PropTypes.func.isRequired,
  onClearAllItems: PropTypes.func.isRequired,
};
